import React from "react";
import { TaskFormMfaqQuestion } from "../../TaskForm/widgets/mfaqQuestion";

function TaskDetailMfaqQuestion({ task }) {
  const question_text = task?.question_text;
  return <TaskFormMfaqQuestion question={question_text} />;
}
export default TaskDetailMfaqQuestion;
